import React from 'react';
import { css } from '@emotion/react';
import { Chip } from '@material-ui/core';
import { Check as CheckIcon } from '@onward-delivery/design/icons';

import { colors } from '@/styles';

// Tap-to-toggle chip for the set-valued fields on this tab — service levels and equipment. Both are
// "pick any number from a fixed vocabulary", so they render the same way.
export default function SelectableChip({ label, selected, onClick }) {
    return (
        <Chip
            clickable
            label={label}
            variant={selected ? 'default' : 'outlined'}
            icon={selected ? <CheckIcon /> : undefined}
            onClick={onClick}
            css={css`
                border-radius: 16px;
                font-weight: 600;
                font-size: 12px;
                height: 30px;

                .MuiChip-icon {
                    width: 14px;
                    height: 14px;
                    margin-left: 10px;
                }

                ${selected
                    ? `
                    background-color: rgba(89, 184, 99, 0.14);
                    border: 1px solid ${colors.greens.primary};
                    color: ${colors.greens.primary};

                    &:hover, &:focus {
                        background-color: rgba(89, 184, 99, 0.14);
                    }

                    .MuiChip-icon {
                        color: ${colors.greens.primary};
                    }
                `
                    : `
                    background-color: #ffffff;
                    border: 1px solid #d5d5d5;
                    color: #4c4c4c;

                    &:hover, &:focus {
                        background-color: #f6f6f6;
                    }
                `}
            `}
        />
    );
}
